export default "__VITE_ASSET__Cb86Z4Fy__"